import React from 'react';
import { PageHeader } from '@/components/ui/PageHeader/PageHeader';
import { PageContainer } from '@/components/ui/PageContainer/PageContainer';
import { AttachmentsManager } from '@/components/Attachments/AttachmentsManager';

export function OrgAttachments() {
  return (
    <PageContainer>
      <PageHeader
        title="Attachments"
        description="Upload, search, rename, delete, and analyze organization files."
      />
      <div className="min-h-[500px]">
        <AttachmentsManager onClose={() => {}} embedded={true} />
      </div>
    </PageContainer>
  );
}


